import { render, staticRenderFns } from "./DirectAccess.vue?vue&type=template&id=ce0af7dc&scoped=true&"
import script from "./DirectAccess.vue?vue&type=script&lang=js&"
export * from "./DirectAccess.vue?vue&type=script&lang=js&"
import style0 from "./DirectAccess.vue?vue&type=style&index=0&id=ce0af7dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0af7dc",
  null
  
)

export default component.exports